import { useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";

export function ModalShell({ icon, title, subtitle, onClose, children }) {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <section className="modal" role="dialog" aria-modal="true" aria-label={title}>
        <header className="modal-header">
          <div className="round-icon">{icon}</div>
          <div>
            <h2 className="modal-title">{title}</h2>
            {subtitle && <div className="subtitle">{subtitle}</div>}
          </div>
          <button
            ref={closeRef}
            type="button"
            className="close-button"
            aria-label="Close modal"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </header>
        {children}
      </section>
    </div>
  );
}
